import { render, staticRenderFns } from "./CrearFuncionario.vue?vue&type=template&id=654af5be&"
import script from "./CrearFuncionario.vue?vue&type=script&lang=js&"
export * from "./CrearFuncionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports